module.exports = __webpack_public_path__ + "img/bn_defImg.96bc5770.jpg";